import styled from "styled-components"

export const PushUrl = styled.div`
  min-width: 55rem;
`
